<template>
  <div id="agenda" class="jf-agenda section padding-top-65 padding-bottom-65">
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <div class="section-headline centered margin-bottom-45">
            <h3>Agenda</h3>
            <span>Plan your day at the Macher Job Fair</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <div class="jf-agenda__timeline">
            <div class="jf-agenda__item" v-for="(item, i) in agenda" :key="i">
              <div class="jf-agenda__time">{{ item.time }}</div>
              <div class="jf-agenda__dot"></div>
              <div class="jf-agenda__card">
                <h4>{{ item.title }}</h4>
                <p>{{ item.description }}</p>
                <span v-if="item.speaker" class="jf-agenda__speaker"><i class="icon-feather-user"></i> {{ item.speaker }}<span v-if="item.speakerTitle" class="jf-agenda__speaker-title"> · {{ item.speakerTitle }}</span></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    agenda: { type: Array, required: true }
  }
};
</script>

<style lang="scss" scoped>
.jf-agenda {
  background: #fff;

  &__timeline {
    position: relative;
    padding-left: 0;

    &::before {
      content: '';
      position: absolute;
      left: 120px;
      top: 10px;
      bottom: 10px;
      width: 2px;
      background: #e0e0e0;
    }
  }

  &__item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 25px;
    position: relative;
  }

  &__time {
    width: 100px;
    text-align: right;
    font-weight: 600;
    color: #2a41e8;
    font-size: 14px;
    padding-top: 12px;
    flex-shrink: 0;
  }

  &__dot {
    width: 14px;
    height: 14px;
    background: #2a41e8;
    border-radius: 50%;
    margin: 14px 15px 0 15px;
    flex-shrink: 0;
    position: relative;
    z-index: 1;
    box-shadow: 0 0 0 4px rgba(42, 65, 232, 0.15);
  }

  &__card {
    flex: 1;
    background: #f9f9f9;
    padding: 15px 20px;
    border-radius: 8px;
    border-left: 3px solid #2a41e8;
    transition: transform 0.2s, box-shadow 0.2s;

    &:hover {
      transform: translateX(4px);
      box-shadow: 0 3px 15px rgba(0, 0, 0, 0.08);
    }

    h4 {
      margin: 0 0 5px;
      font-size: 16px;
      color: #333;
    }

    p {
      margin: 0;
      font-size: 14px;
      color: #777;
    }
  }

  &__speaker {
    display: inline-block;
    margin-top: 8px;
    font-size: 13px;
    font-weight: 600;
    color: #2a41e8;

    i {
      margin-right: 4px;
      font-size: 12px;
    }
  }

  &__speaker-title {
    font-weight: 400;
    color: #777;
  }
}

@media (max-width: 768px) {
  .jf-agenda {
    &__timeline::before {
      left: 15px;
    }

    &__item {
      flex-wrap: wrap;
    }

    &__time {
      width: auto;
      text-align: left;
      padding-left: 40px;
      padding-top: 0;
      margin-bottom: 5px;
      width: 100%;
    }

    &__dot {
      position: absolute;
      left: 9px;
      top: 3px;
      margin: 0;
    }

    &__card {
      margin-left: 40px;
      width: calc(100% - 40px);
    }
  }
}
</style>
